import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FinancialManagementService} from '../../../../pages/financial/_services/financial-management.service';
import {FinancialSetting} from '../../../../pages/financial/_models/financial-management.model';
import {FinancialChartAccountOptions} from '../../../../pages/financial/_models/financial-account.model';
import {FinancialChartService} from '../../../../pages/financial/_services/financial-chart.service';

@Component({
  selector: 'acabim-admin-onboarding-financial-maintenance',
  templateUrl: './onboarding-financial-maintenance.component.html',
  styleUrls: ['../styles.scss', './onboarding-financial-maintenance.component.scss']
})
export class OnboardingFinancialMaintenanceComponent implements OnInit {

  isLoading = false;
  accounts: FinancialChartAccountOptions[] = [];
  defaultCurrency: { name: string }[] = [];
  showContingencyAccounts = false;
  taxType: { name: string }[] = [];
  financialForm = new FormGroup({
    contingency: new FormControl(null),
    contingencyFund: new FormControl(null),
    maintenanceItems: new FormControl(null)
  });

  constructor(
      private readonly financialService: FinancialManagementService,
      private readonly financialChartService: FinancialChartService
  ) { }

  ngOnInit(): void {
    this.getPreferences();
    if (this.financialForm) {
      this.financialForm?.get('contingency')?.valueChanges.subscribe((data: any) => {
        console.dir(data);
        this.showContingencyAccounts = data;
      });
    }
  }

  getPreferences(): void {
    this.isLoading = true;
    this.financialChartService.getChartOfAccountsAsOptions(false, true).subscribe(accounts => {
      this.accounts = accounts;
      this.financialService.getCurrentSettings().subscribe(currentSettingData => {
        this.isLoading = false;
        console.dir(currentSettingData);
        if(this.financialForm && currentSettingData) {
          this.financialForm.get('maintenanceItems')?.setValue(currentSettingData?.maintenance_items === 1);
          let CFAccount = null;
          this.accounts.map((data) => {
            const match = data.items.filter(x => x.value === currentSettingData?.contingency_fund).shift();
            if(match) {
              CFAccount = match.value;
            }
          });
          if (CFAccount) {
            this.financialForm?.get('contingency')?.setValue(true);
            this.showContingencyAccounts = true;
            this.financialForm?.get('contingencyFund')?.setValue(CFAccount);
          } else {
            this.financialForm?.get('contingency')?.setValue(false);
            this.showContingencyAccounts = false;
            this.financialForm?.get('contingencyFund')?.setValue(null);
          }
        }
      });
    });
  }

  submit(value: boolean) {
    const payload = this.gather();
    this.isLoading = true;
    this.financialService.setCurrentSettings(payload).subscribe(res => {
      this.getPreferences();
    });
  }

  gather(): FinancialSetting {
    return {
      contingency_fund: this.showContingencyAccounts && this.financialForm.get('contingencyFund')?.value ? this.financialForm.get('contingencyFund')?.value : 0,
      maintenance_items: this.financialForm.get('maintenanceItems')?.value ? 1 : 0,
    };
  }

} // EOC
